var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('div',{staticClass:"padding-container-lg"},[_c('v-patient-form',{attrs:{"patient":_vm.patient,"actionType":"add"},on:{"submit":_vm.validateBeforeSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }